import React, { useEffect, useState } from "react";
import { getEvent } from '../../api/blogs'
import { Link } from "react-router-dom";
import bImg from '../../images/blog/shape.png'
import bImg2 from '../../images/blog/shape2.png'
import SectionTitle from "../SectionTitle/SectionTitle";


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogSection = () => {
    const [events, setEvents] = useState(null);
    const apiUrl = process.env.REACT_APP_PUBLIC_API_URL;
        
    useEffect(() => {
        getEvent().then(setEvents);
    }, []);

    if (!events) return null;

    return (
        <div 
            className="wpo-blog-area-s2 section-padding section-bg"
            style={{
                marginBottom: "25vh"
            }}
        >
            <div className="container">
                <SectionTitle subTitle={'Special Events'} Title={'Latest Posts From Our Special Events'} />
                <div className="wpo-blog-wrap">
                    <div className="row align-items-center">
                        {events.slice(0, 6).map((blog, bl) => (
                            <div className="col-lg-4 col-md-6 col-12" key={bl}>
                                <div 
                                    className="blog-item"
                                    style={{
                                        height: "240px",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        flex: "1",
                                        boxShadow: "0 2px 4px rgb(0, 0, 0, 0.2)",
                                        borderRadius: "10px"
                                    }}
                                >
                                    <div className="blog-img">
                                        <img 
                                            src={`${apiUrl}/storage/`+blog.banner} 
                                            alt="" 
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                borderRadius: "10px"
                                            }}
                                        />
                                    </div>
                                    <div className="blog-content">
                                        <ul>
                                            <li><a href="blog-single.html">{blog.create_at}</a></li>
                                            <li>{blog.eventName}</li>
                                        </ul>
                                        <h2><Link onClick={ClickHandler} to={`/event-single/${blog.id}`}>{blog.eventName}</Link></h2>
                                        <Link className="arrow-btn" onClick={ClickHandler} to={`/event-single/${blog.id}`}><i
                                            className="fi flaticon-right-arrow-1"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="shape-1"><img src={bImg} alt=""/></div>
            <div className="shape-2"><img src={bImg2} alt=""/></div>
        </div>
    );
}

export default BlogSection;